import { Component } from 'react';
//@ts-expect-error not yet migrated
import { underlineOrHighLight, clearHighlights } from 'InpageEditorUI/lib/dom';
//@ts-expect-error not yet migrated
import shallowEqual from 'ContentEditorUI/utils/shallowEqual';
class XrayReadabilityContainer extends Component {
  constructor(props) {
    super(props);
    this.state = {
      //setting this as local state for now but in the future, can be a redux state if need be
      highlightedElements: []
    };
  }
  componentDidUpdate(prevProps) {
    const {
      xrayReadabilityType,
      xrayReadabilityArr
    } = prevProps;
    const currentXrayReadabilityArr = this.props.xrayReadabilityArr;

    //check if readability config arrray had changed
    let xrayReadabilityArrHadChanged = false;
    if (xrayReadabilityArr.length !== currentXrayReadabilityArr.length) {
      xrayReadabilityArrHadChanged = true;
    } else {
      const hasDifferentConfig = (element, index, array) => !shallowEqual(array[index], currentXrayReadabilityArr[index]);
      xrayReadabilityArrHadChanged = xrayReadabilityArr.some(hasDifferentConfig);
    }

    //clear if an item gets fixed or more items to fix are added
    if (xrayReadabilityArrHadChanged) {
      clearHighlights(this.state.highlightedElements);
      this.setState({
        highlightedElements: []
      });
    }
    if (xrayReadabilityType !== this.props.xrayReadabilityType) {
      if (this.props.xrayReadabilityType && this.props.xrayReadabilityArr.length) {
        let newCombinedHighlightedElements = [];

        //expecting to get this data from BE when it is ready
        currentXrayReadabilityArr.forEach(config => {
          const newHighlightedElements = underlineOrHighLight(config, this.props.xrayReadabilityType);
          newCombinedHighlightedElements = [...newCombinedHighlightedElements, ...newHighlightedElements];
        });
        this.setState({
          highlightedElements: newCombinedHighlightedElements
        });
      }
    }
  }
  render() {
    return null;
  }
}
export default XrayReadabilityContainer;